import { calcPriceNdsByPrice } from '@/lib/nds';
import Decimal from "decimal.js-light";

export interface ApplicationPosition {
    price: string;
    [key: string]: any;
}

export const useApplicationPositionCalculator = (position: ApplicationPosition, ndsRate?: string, priceField?: string) : {
    getCostForQuantity: (quantity: string) => string,
    getCostNdsForQuantity: (quantity: string) => string,
} => {
    const getPrice = (): string => priceField && position[priceField] ? position[priceField] : position.price;
    const calculateWithNds = (price: string): string => calcPriceNdsByPrice(price, ndsRate);
    const getPriceNds = () => calculateWithNds(getPrice());
    const getCostForQuantity = (quantity: string): string => {
        return new Decimal(getPrice()??'0')
            .mul(new Decimal(quantity??0))
            .toString();
    };

    return {
        getCostForQuantity: (quantity: string): string => getCostForQuantity(quantity),
        getCostNdsForQuantity: (quantity: string): string => calculateWithNds(getCostForQuantity(quantity)),
    };
}
